import React, { useEffect, useContext } from "react";
import SurveyContext from "../../../contexts/SurveyContext";
import CurrentQuestionContext from "../../../contexts/CurrentQuestionContext";
import { Container, Title, SubTitle } from "./finish.styles";

const DropDown = () => {
  const setIsAlreadyAnswered = useContext(SurveyContext).setIsAlreadyAnswered;
  const setIsSuccessText = useContext(CurrentQuestionContext).setIsSuccessText;
  const title = useContext(CurrentQuestionContext).question.title;
  const subtitle = useContext(CurrentQuestionContext).question.subtitle;

  useEffect(() => {
    const timer = setTimeout(async () => {
      setIsSuccessText(true);
      await new Promise((r) => setTimeout(r, 500));

      setIsAlreadyAnswered(true);
      console.log("This will run after 1 second!");
    }, 6000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Container>
      <Title dir="auto">{title}</Title>
      <SubTitle dir="auto">{subtitle}</SubTitle>
    </Container>
  );
};

export default DropDown;
